import React, { ReactElement } from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
// import moment, { Moment } from 'moment';
// import 'moment/locale/ru';
import 'dayjs/locale/ru';
import locale from 'antd/es/date-picker/locale/ru_RU';
import styled from 'styled-components';
import { colorsPalette } from '../../styles/colors-palette';
import { ValidationStatus } from '../../../infrastructure/types/common/common-types';

const DATE_FORMAT = 'DD.MM.YYYY';
const MONTH_HEADER_FORMAT = 'MMMM';

const pickerLocale = {
  ...locale,
  lang: {
    ...locale.lang,
    monthFormat: MONTH_HEADER_FORMAT,
  },
};

type DateRangeSizeType = 'large' | 'middle' | 'small';

//TODO: add locale param on demand
interface CalendarRangePickerProps {
  placeholder?: [string, string];
  value?: [Date | null, Date | null];
  disabled?: boolean;
  size?: DateRangeSizeType;
  onChange?: (dates: RangeValue) => void;
  validateStatus?: ValidationStatus;
  className?: string;
  allowClear?: boolean;
}

const { RangePicker: AntRangePicker } = AntDatePicker;

type RangeValue = [Date | null, Date | null] | null;
type AntRangeValue = [Dayjs | null, Dayjs | null] | null;

function CalendarRangePicker({
  placeholder,
  value,
  disabled,
  size,
  onChange,
  className,
  validateStatus,
  allowClear = false,
}: CalendarRangePickerProps): ReactElement {
  const antOnChange = (values: AntRangeValue) => {
    if (values !== undefined) {
      if (values === null) {
        onChange && onChange(null);
        return;
      }

      onChange && onChange([values[0]?.toDate() ?? null, values[1]?.toDate() ?? null]);
    }
  };
  let antValue: AntRangeValue = [null, null];

  if (value) {
    antValue = [value[0] ? dayjs(value[0]) : null, value[1] ? dayjs(value[1]) : null];
  }

  // TODO add locale param on demand
  // TODO fix focus
  return (
    <Wrapper className={className}>
      <AntRangePicker
        value={antValue}
        size={size ? size : 'large'}
        format={DATE_FORMAT}
        placeholder={placeholder}
        disabled={disabled}
        onChange={antOnChange}
        locale={pickerLocale}
        allowClear={allowClear}
        status={validateStatus}
        open={true}
        getPopupContainer={trigger => trigger.parentElement as HTMLElement}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  .ant-picker-dropdown {
    position: relative !important;
    display: flex;
    justify-content: center;
  }

  .ant-picker-panel-container {
    box-shadow: none !important;
  }

  .ant-picker-panels > *:first-child button.ant-picker-header-next-btn {
    visibility: visible !important;
  }

  .ant-picker-panels > *:first-child button.ant-picker-header-super-next-btn {
    visibility: visible !important;
  }

  .ant-picker-panels > *:last-child {
    display: none !important;
  }

  .ant-picker-panel-container,
  .ant-picker-footer {
    width: 280px !important;
  }

  .ant-picker-footer-extra > div {
    flex-wrap: wrap !important;
  }

  .ant-picker-header-view .ant-picker-month-btn {
    text-transform: capitalize;
  }
`;

export { type RangeValue, CalendarRangePicker };
